<template>
  <div id="homework">
    <div v-loading="loading">
      <el-button
        type="primary"
        @click="toAddHomework"
        v-auth="'classRoomTeaching_toAddHomework'"
        >发布作业</el-button
      >
      <div v-for="(item, index) in homeworkResult" :key="index">
        <div class="homework_box" @click="showHomeworkDetail(item.homeworkId)">
          <div class="flex-between">
            <div>
              作业{{ index + 1 }}
              <el-tag type="warning" v-if="item.courseType == 1">同步</el-tag>
                <el-tag v-else>自建</el-tag>
            </div>

            <div>
              <span>发布于 {{ item.createTime }}</span>
              <span>
                <i
                  v-if="item.courseType == 2"
                  @click.stop="deleteHomeworkById(item.homeworkId)"
                  class="el-icon-delete mainColor"
                  title="删除"
                ></i>
              </span>
            </div>
          </div>
          <div class="flex-between">
            <div class="homework_item">
              <div class="homework_item_start">{{ item.commitCount }}</div>
              <div>已提交</div>
            </div>
            <div class="homework_item">
              <div class="homework_item_start">{{ item.unCommitCount }}</div>
              <div>未提交</div>
            </div>
            <div class="homework_item">
              <el-progress
                type="circle"
                :percentage="Number(item.commitPer)"
                :width="50"
              ></el-progress>
              <div>提交率</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      size="50%"
    >
      <el-tabs v-model="activeName2" @tab-click="handleClick" v-if="drawer">
        <el-tab-pane label="作业内容" name="作业内容">
          <homeworkContent
            :homeworkId="homeworkId"
            v-if="activeName2 == '作业内容'"
          ></homeworkContent>
        </el-tab-pane>
        <el-tab-pane label="答题统计" name="答题统计">
          <homeworkStatistics
            v-if="activeName2 == '答题统计'"
            :homeworkId="homeworkId"
            >112</homeworkStatistics
          >
        </el-tab-pane>
        <el-tab-pane label="提交情况" name="提交情况">
          <submitResult
            @examCardDialogChange="examCardDialogChange"
            v-if="activeName2 == '提交情况'"
            :homeworkId="homeworkId"
          ></submitResult>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>

    <el-dialog
      :visible.sync="examCardDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="70%"
    >
      <homeworkQuestion
        :homeworkQuestionData="homeworkQuestionData"
        v-if="examCardDialog"
      ></homeworkQuestion>
    </el-dialog>
  </div>
</template>

<script>
import homeworkQuestion from "./homeworkQuestion";
import homeworkStatistics from "./homeworkStatistics";
import homeworkContent from "./homeworkContent";
import submitResult from "./submitResult";
export default {
  components: {
    homeworkQuestion,
    homeworkStatistics,
    homeworkContent,
    submitResult,
  },
  data() {
    return {
      loading: false,
      drawer: false,
      examCardDialog: false,
      activeName: "已提交",
      activeName2: "作业内容",
      homeworkId: null,
      homeworkResult: [],
      homeworkDetail: {
        unCommitCount: "",
        commitCount: "",
      },
      homeworkQuestionData: {
        id: null,
        studentId: null,
      },
    };
  },
  props: {
    homeworkData: {},
  },
  computed: {},
  created() {},
  methods: {
    toAddHomework() {
      this.$router.push({
        path: "/addHomework",
        query: {
          classInfoId: this.homeworkData.classInfoId,
          scheduleInfoId: this.homeworkData.scheduleInfoId,
          courseId: this.homeworkData.courseId,
        },
      });
    },

    showHomeworkDetail(id) {
      this.homeworkId = id;
      this.activeName2 = "作业内容";
      this.drawer = true;
    },

    handleClick() {},

    getHomeworkResultByClassId() {
      this.loading = true;
      this.api.homework
        .getHomeworkResultByClassId({
          classInfoId: this.homeworkData.classInfoId,
          scheduleInfoId: this.homeworkData.scheduleInfoId,
        })
        .then((result) => {
          if (result.success) {
            this.homeworkResult = result.data;
            this.loading = false;
          } else {
            this.$message.error(result.message);
            this.loading = false;
          }
        });
    },

    examCardDialogChange(val) {
      this.homeworkQuestionData = val;
      this.examCardDialog = true;
    },

    /*--------------------------------------------删除课后作业--------------------------------------------*/
    deleteHomeworkById(id) {
      let number = 0;
      this.api.homework.checkHomeworkExercise({ id: id }).then((result) => {
        number = result.data;
      });
      this.$confirm(
        number == 0 ? "确定删除吗？" : "该练习已有学员提交,确定删除吗？",
        "系统消息",
        {
          type: "warning",
        }
      ).then(() => {
        this.api.homework
          .deleteHomeworkById({ id: id })
          .then((result) => {
            if (result.success) {
              this.getHomeworkResultByClassId();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
  },
  mounted() {
    this.getHomeworkResultByClassId();
  },
  watch: {
    "homeworkData.scheduleInfoId": function (newVal) {
      this.getHomeworkResultByClassId();
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.homework_box {
  border: 1px solid #ccc;
  padding: 20px;
  margin-top: 20px;
  cursor: pointer;
}
.homework_item {
  flex: 1;
  text-align: center;
  margin-top: 20px;
}
.homework_item_start {
  font-size: 36px;
  font-weight: 400;
}
.homework_item_end {
  border: 1px solid #ccc;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 40px;
  margin: 5px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/homework.vue